const RAG_ACCENT_COLOR_MAP = Object.freeze({
  green: 'green',
  amber: '#e8a700',
  red: 'red',
});

const normalizeHexColor = (value) => {
  const raw = String(value || '').trim();
  const hex = raw.startsWith('#') ? raw.slice(1) : raw;

  if (/^[0-9a-fA-F]{3}$/.test(hex)) {
    return `#${hex
      .split('')
      .map((ch) => ch + ch)
      .join('')
      .toLowerCase()}`;
  }

  if (/^[0-9a-fA-F]{6}$/.test(hex)) {
    return `#${hex.toLowerCase()}`;
  }

  return '';
};

export const normalizeRagAccentColor = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const normalizedHex = normalizeHexColor(raw);
  if (normalizedHex) return normalizedHex;

  return RAG_ACCENT_COLOR_MAP[raw.toLowerCase()] || '';
};

export { RAG_ACCENT_COLOR_MAP };
